import router from './router'
import App from 'App'

router.start(App, '#app')



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/